module.exports = __webpack_public_path__ + "assets/img/yonghu.a697c3e9.png";